module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-xs-fb571cf5bc2e0de98962877435f66e16.png";